import { createInstance, MatomoProvider as MatomoReactProvider } from '@jonkoops/matomo-tracker-react';
import { ReactNode, useMemo } from 'react';
import { useCookieConsent } from '@/hooks/useCookieConsent';

interface MatomoProviderProps {
    children: ReactNode;
}

export function MatomoProvider({ children }: MatomoProviderProps) {
    // Solo cargamos analítica si el usuario consintió las cookies. (Blindaje legal — ítem 13)
    const analyticsConsent = useCookieConsent((s) => s.analytics);

    const instance = useMemo(() => {
        if (analyticsConsent !== 'granted') {
            return null;
        }

        const urlBase = import.meta.env.VITE_MATOMO_URL || '';
        const siteId = parseInt(import.meta.env.VITE_MATOMO_SITE_ID || '1', 10);

        // Only create Matomo instance if URL is configured
        if (!urlBase || urlBase === 'http://127.0.0.1/matomo') {
            console.log('Matomo: Disabled in development mode');
            return null;
        }

        console.log('Matomo: Initializing with URL:', urlBase, 'Site ID:', siteId);

        return createInstance({
            urlBase,
            siteId,
            linkTracking: true,
            configurations: {
                disableCookies: false,
                setSecureCookie: window.location.protocol === 'https:',
                setRequestMethod: 'POST',
            },
        });
    }, [analyticsConsent]);

    // If no instance (development), just render children
    if (!instance) {
        return <>{children}</>;
    }

    return (
        <MatomoReactProvider value={instance}>
            {children}
        </MatomoReactProvider>
    );
}
